export default {
	"11b035e8c4da2efd29c6f9082c071b76": "There was an error in loading the map",
	"5b50afe4b7d9b4c86854715312e6d57b": "Residential communities/office buildings/schools, etc"
}
